






























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Framework extends Vue {
  @Prop() private setting!: object;

  public data() {
    return {
      title: "",
      map: {
        setting: "设置向导",
        manager: "活动管理",
        log: "操作记录",
      },
    };
  }

  public async loginOut() {
    // console.log(123);
    // try {
    //   const url = await this.$store.dispatch("loginOut", {
    //     activity_id: 14,
    //   });
    //   location.href = url.login_url;
    // } catch (error) {
    //   (this as any).$message.error(error.msg || error.message || error);
    // }
    localStorage.removeItem('token')
    location.href = "https://fw.jd.com/home/sers.action";
  }

  get defaultSelectedKeys() {
    let defaultSelcet: any = this.$router.currentRoute.name;
    // 创建活动默认展示活动管理
    if (this.$router.currentRoute.path.indexOf("create") != -1) {
      defaultSelcet = "manager";
    }
    this.$data.title = this.$data.map[defaultSelcet];
    return defaultSelcet || "setting";
  }

  /**
   * tab切换
   */
  public handleOpen(route: any) {
    if (this.$router.currentRoute.name != route) {
      this.$data.title = this.$data.map[route];
      this.$router.push({ name: route });
    }
  }
}
